<div class="column">
	<div class="line-list" *ngIf="!modelValue?.length">
		<!-- no lines yet -->
		<div class="add-new-line always-show">
			<div role="button" class="add-line-button" (click)="addLine('1')" [title]="'ADD_LINE' | translate">
				{{ "ADD_LINE" | translate }} <i class="far fa-plus"></i>
			</div>
			<div class="hairline"></div>
		</div>
	</div>

	<div class="line-list" *ngIf="modelValue?.length">
		<div *ngFor="let line of modelValue; let i = index; trackBy: trackByFn;">
			<!-- Input block -->
			<div class="block" (click)="seekToTime(line.startSeconds)" [class.block-error]="line.invalidEmptyLine || line.invalidEmpty" [class.active]="inViewSubtitleId === line.id">
				<div class="index-number">
					<span>#{{ i < 9 ? '0' + line.id : line.id }}</span>
				</div>

				<div class="times-container">
					<!-- start time -->
					<div class="time" [class.active-hover]="line.id === canSetStartTimeId && subtitleService.highlightCanSetInput === 'start'">
						<bb-button [disabled]="line.id !== canSetStartTimeId" [naked]="true" class="seek-button"
							(click)="setLineTime(i, 'start', line.id)"
							[title]="'INSERT_CURRENT_TIME' | translate">
							<i class="far fa-clock"></i>
						</bb-button>
						<bb-timecode-editor [class.flash]="line.id === highlightId" 
							[inMatFormField]="true"
							[hideFrames]="false" [useMilliseconds]="true" [forceHourDisplay]="true"
							[min]="modelValue[i - 1] ? modelValue[i - 1].endSeconds : 0" 
							[max]="line.endSeconds ? line.endSeconds - 0.01 : duration"
							[(ngModel)]="line.startSeconds" [name]="'start-time-' + i"
							(ngModelChange)="onChange('start', i)"></bb-timecode-editor>
					</div>
					<!-- end time -->
					<div class="time" [class.active-hover]="line.id === canSetEndTimeId && subtitleService.highlightCanSetInput === 'end'">
						<bb-button [disabled]="line.id !== canSetEndTimeId" [naked]="true" class="seek-button"
							(click)="setLineTime(i, 'end', line.id)"
							[title]="'INSERT_CURRENT_TIME' | translate">
							<i class="far fa-clock"></i>
						</bb-button>
						<bb-timecode-editor [class.flash]="line.id === highlightId"
							[inMatFormField]="true"
							[hideFrames]="false" [useMilliseconds]="true" [forceHourDisplay]="true"
							[min]="line.startSeconds ? line.startSeconds + 0.01 : 0"
							[max]="modelValue[i + 1] ? modelValue[i + 1].startSeconds : duration" 
							[(ngModel)]="line.endSeconds" [name]="'end-time-' + i"
							(ngModelChange)="onChange('end', i)"></bb-timecode-editor>
					</div>
				</div>

				<!-- text -->
				<div class="text-container">
					<textarea #textAreaInputs required type="text" [name]="'line-name-' + line.id" class="text-input" placeholder="" rows="3"
						[(ngModel)]="line.text" (ngModelChange)="onChange('text', i);" (focusout)="line.new = false; onChange('text', i)">
					</textarea>
					<div class="text-error">
						<span *ngIf="line.invalidEmptyLine"> {{ "INVALID_EMPTY_LINE" | translate }}</span>
						<span *ngIf="line.invalidEmpty"> {{ "INVALID_EMPTY" | translate }}</span>
					</div>
				</div>

				<div class="button-container">
					<bb-button [naked]="true" (click)="remove(i)" [title]="'REMOVE_LINE' | translate" data-cy="subtitle-delete-line">
						<i class="far fa-trash"></i>
					</bb-button>
				</div>
			</div>

			<!-- add new -->
			<div class="add-new-line" [class.always-show]="i === modelValue.length - 1"
			 	[class.disabled-add]="modelValue[i].endSeconds === modelValue[i + 1]?.startSeconds || (duration && line.endSeconds >= duration)"
			>
				<div role="button" class="add-line-button" (click)="addLine(line.id)" [title]="'ADD_LINE' | translate">
					{{ "ADD_LINE" | translate }} <i class="far fa-plus"></i>
				</div>
				<div class="hairline"></div>
			</div>
		</div>
	</div>
</div>
